package org.moxultimate.topwithmox.showscrud.module

import org.koin.dsl.module
import org.moxultimate.topwithmox.shows.api.ShowsRepository
import org.moxultimate.topwithmox.showscrud.api.ShowsCRUDRepository
import org.moxultimate.topwithmox.showscrud.main.ShowsCRUDViewModel

val showsCRUDModule = module {

    // CRUD repository — reuses the HttpClient singleton registered in showsModule
    single { ShowsCRUDRepository(httpClient = get()) }

    // ViewModel — factory so each composable gets a fresh instance with its own scope
    factory { ShowsCRUDViewModel(repository = get<ShowsRepository>(), crudRepository = get()) }
}
